import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { Field, SelectField } from "./components/FormFields";
import { useCouponForm } from "./hooks/useCouponForm";

const couponTypeOptions = [
  { value: "single_use", label: "Single Use" },
  { value: "multi_use", label: "Multiple Use" },
];

export default function AddCouponForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { brandId, offerId, couponId } = useParams();
  const initialValues = location.state?.coupon || null;
  const { isEdit, form, error, fieldErrors, isSubmitting, handleFieldChange, handleSubmit } = useCouponForm({
    offerId,
    couponId,
    initialValues,
    onSaved: () => navigate(`/services/loyalty-offers/${brandId}/offers/${offerId}/coupons`, { state: location.state || {} }),
  });

  return (
    <Layout>
      <main>
        <div className="mx-auto my-2 max-w-4xl px-4 lg:px-0">
          <div className="rounded-2xl bg-white shadow-lg">
            <div className="mx-auto rounded-t-2xl bg-slate-50 p-6">
              <h1 className="text-2xl font-bold tracking-tight text-gray-900">
                {isEdit ? "Edit Coupon" : "Add Coupon"}
              </h1>
              <p className="mt-1 text-sm text-gray-600">
                {isEdit ? "Update this coupon details." : "Create a new coupon for this offer."}
              </p>
            </div>

            <form className="space-y-8 p-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <Field
                  id="code"
                  name="code"
                  label="Coupon Code *"
                  value={form.code}
                  onChange={handleFieldChange}
                  placeholder="Enter coupon code"
                  error={Boolean(fieldErrors.code)}
                  errorMessage={fieldErrors.code}
                />

                <SelectField
                  id="coupon_type"
                  name="coupon_type"
                  label="Coupon Type *"
                  value={form.coupon_type}
                  onChange={handleFieldChange}
                  options={couponTypeOptions}
                  placeholder="Select coupon type"
                  error={Boolean(fieldErrors.coupon_type)}
                  errorMessage={fieldErrors.coupon_type}
                />
              </div>

              {/* {error ? <p className="text-sm text-red-600">{error}</p> : null} */}

              <div className="flex flex-wrap gap-2">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="inline-flex items-center rounded-xl bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600 disabled:cursor-not-allowed disabled:bg-cyan-300"
                >
                  {isSubmitting ? "Saving..." : isEdit ? "Save Coupon" : "Add Coupon"}
                </button>
                <button
                  type="button"
                  className="inline-flex items-center rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                  onClick={() => navigate(`/services/loyalty-offers/${brandId}/offers/${offerId}/coupons`)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </Layout>
  );
}
